import { render } from "./view-generator.vue?vue&type=template&id=38c2116d"
import script from "./view-generator.vue?vue&type=script&lang=js"
export * from "./view-generator.vue?vue&type=script&lang=js"

import "./view-generator.vue?vue&type=style&index=0&id=38c2116d&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__